export function gridKeikkas_isSame(a, b) {
  if (a.keikkaId != b.keikkaId) return false;
  if (a.tyomaaId != b.tyomaaId) return false;
  if (a.vehicleId != b.vehicleId) return false;
  if (a.asiakasId != b.asiakasId) return false;
  if (a.keikkaTilaId != b.keikkaTilaId) return false;
  if (a.betoniSijaintiId != b.betoniSijaintiId) return false;
  else if (a.betoniAsiakasId != b.betoniAsiakasId) return false;

  if (a.pumppuAika != b.pumppuAika) return false;
  if (a.pumppuAsiakasId != b.pumppuAsiakasId) return false;
  if (a.pumppuKesto != b.pumppuKesto) return false;
  if (a.pumppuLinja != b.pumppuLinja) return false;
  if (a.pumppuPuomi != b.pumppuPuomi) return false;

  if (a.isKeikka != b.isKeikka) return false;
  if (a.isPalkki != b.isPalkki) return false;
  if (a.isBetoniSuoraLaskutus != b.isBetoniSuoraLaskutus) return false;
  if (a.isPumppuSuoraLaskutus != b.isPumppuSuoraLaskutus) return false;

  if (a.tyhjänäTyömaalle != b.tyhjänäTyömaalle) return false;
  if (a.tyomaaAjoOhje != b.tyomaaAjoOhje) return false;
  if (a.tyomaaContactPersonId != b.tyomaaContactPersonId) return false;
  if (a.tyomaaMemo != b.tyomaaMemo) return false;
  if (a.foreignKey != b.foreignKey) return false;
  if (a.keikkaAjoOhje != b.keikkaAjoOhje) return false;
  if (a.keikkaComment != b.keikkaComment) return false;
  if (a.keikkaOtsikko != b.keikkaOtsikko) return false;
  if (a.kommentti != b.kommentti) return false;
  if (a.laskuViite != b.laskuViite) return false;
  if (a.locked != b.locked) return false;

  if (a.ownerAsiakasId != b.ownerAsiakasId) return false;
  if (a.personId != b.personId) return false;
  if (a.sourceAsiakasId != b.sourceAsiakasId) return false;
  if (a.asiakasContactPersonId != b.asiakasContactPersonId) return false;

  if (a.betoniVahvistettu != b.betoniVahvistettu) return false;
  for (let i = 0; i < a.betonit.length; i++) {
    if (!gridKeikkaBetoni_isSame(a.betonit[i], b.betonit[i])) return false;
  }
  return true;
}

// betoniComment
// betoniString
// isNopea
// kayttoIkaId
// keikkaBetoniId
// laatuId
// lujuusId
// m3
// notkeusId
// raeKokoId
// rasitusluokat

function gridKeikkaBetoni_isSame(a, b) {
  if (a.keikkaBetoniId != b.keikkaBetoniId) return false;
  if (a.betoniComment != b.betoniComment) return false;
  if (a.betoniString != b.betoniString) return false;
  if (a.isNopea != b.isNopea) return false;
  if (a.kayttoIkaId != b.kayttoIkaId) return false;
  if (a.laatuId != b.laatuId) return false;
  if (a.lujuusId != b.lujuusId) return false;
  if (a.m3 != b.m3) return false;
  if (a.notkeusId != b.notkeusId) return false;
  if (a.raeKokoId != b.raeKokoId) return false;
  if (a.rasitusluokat != b.rasitusluokat) return false;
  return true;
}

export function gridKeikka_copyJSON(gridKeikka, stringify = false) {
  if (!gridKeikka) return null;
  const gridKeikkaCopy = JSON.stringify(gridKeikka, (key, value) => {
    if (key === "keikkaGroup") return undefined;
    if (key === "handleChange") return undefined;
    if (key === "auth") return undefined;
    if (key === "socket") return undefined;
    return value;
  });
  if (!gridKeikkaCopy) return null;
  if (stringify) {
    return gridKeikkaCopy;
  } else {
    return JSON.parse(gridKeikkaCopy);
  }
}
